import { jsonp } from '@ifeng-fe/ui_base';

/**
 * 提交调查
 * @param {String} id 调查id
 * @param {String} sur 选项拼接字符串
 */
export const postSurvey = async (id, sur) => {
    try {
        const data = await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${sur}`, {
            data: { id },
            jsonpCallback: 'callback',
            cache: false,
        });

        return data;
    } catch (e) {
        console.error(e);
    }
};

/**
 * 获取热点调查
 * @param {String} type
 * @param {Number} num
 */
export const getSurveyHot = async (type = 'hot', num = 5) => {
    try {
        const res = await jsonp('//sv.ifeng.com/index.php/survey/getsort', {
            data: { type, num },
            jsonpCallback: 'callback',
            cache: false,
        });

        if (res.ifsuccess) {
            return res.data;
        }
    } catch (e) {
        console.error(e);
    }
};
